import { getAllProgenyOptions } from "@/api/progeny";

const state = {
    progenyOptions: null
};

const mutations = {
    GET_ALL_OPTIONS: (state, data) => {
        state.progenyOptions = data;
    },
};

const actions = {
    async getAllProgenyOptions({ commit }) {
        let res = await getAllProgenyOptions();
        if (res) {
            commit("GET_ALL_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/progeny.js